const endpoints = {
    // Auth endpoints
    auth: {
        signup: '/auth/signup',
        login: '/auth/login',
        logout: '/auth/logout',
        resetPassword: '/auth/reset-password',
        googleLogin: '/auth/google-login',
        anonymousLogin: '/auth/anonymous-login',
        userStatus: '/auth/user-status',
        linkAccount: '/auth/link-account',
    },

    // Subscription endpoints
    subscriptions: {
        list: '/subscriptions',
        create: '/subscriptions',
        defaults: '/subscriptions/defaults',
        detail: (id) => `/subscriptions/${id}`,
        update: (id) => `/subscriptions/${id}`,
        delete: (id) => `/subscriptions/${id}`,
    },

    // Analytics endpoints
    analytics: {
        totalSpend: '/analytics/total-spend',
        categoryBreakdown: '/analytics/category-breakdown',
        spendTrend: '/analytics/spend-trend',
        mostExpensive: '/analytics/most-expensive',
        upcomingBillings: '/analytics/upcoming-billings',
        potentialSavings: '/analytics/potential-savings',
    },

    // User endpoints
    user: {
        profile: '/user/profile',
        updateProfile: '/user/update-profile',
        updatePreferences: '/user/update-preferences'
    },

    // Feedback endpoints
    feedback: {
        submit: '/feedback/submit',
        wishlist: (featureId) => `/feedback/wishlist?feature_id=${encodeURIComponent(featureId)}`
    },
};

export default endpoints; 